import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { area } from 'app/masters/models/branch-master.model';
import { SelectionModel } from '@angular/cdk/collections';
import { LocationService } from '../../location.service';


@Component({
  selector: 'app-search-area-master',
  templateUrl: './search-area-master.component.html',
  styleUrls: ['./search-area-master.component.scss']
})
export class SearchAreaMasterComponent implements OnInit {
  dataSource = new MatTableDataSource<area>();
  selection = new SelectionModel<any>(true, []);
  showSpinner = false;

fullData: any[] = [];
viewData: any[] = [];
pageSize = 100;
pageIndex = 0;
  displayedColumns: string[] = ['areaname', 'pincode','cityname','districtname' ,'statename','countryname','isActive'];
  constructor(public dialog: MatDialog ,public dialogRef: MatDialogRef<SearchAreaMasterComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any,     public locationService: LocationService
) { 

  }

  ngOnInit(): void {
    this.getarealistAll();
  
  }
  // getarealistAll() {
  //   this.showSpinner = true;
  //   this.locationService.getAreaItem(0).subscribe(data => {
      
  //     console.log("Length of the data:", data.length);
  //     this.dataSource.data = []
  //     this.dataSource.data = data;
  //     this.showSpinner = false;
  //   }, err => {
  //   this.showSpinner = false;
  //   }
  
  // )
  // }
  getarealistAll() {
  this.showSpinner = true;
  this.locationService.getAreaItem(0).subscribe(data => {
    this.fullData = data;
    this.viewData = this.fullData.slice(0, this.pageSize); 
    this.dataSource.data = this.viewData;
    this.pageIndex = 1;
    this.showSpinner = false;
  }, err => {
    this.showSpinner = false;
  });
}
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }


  onScroll(event: any) {
  const scrollTop = event.target.scrollTop;
  const scrollHeight = event.target.scrollHeight;
  const offsetHeight = event.target.offsetHeight;

  if (scrollTop + offsetHeight >= scrollHeight - 10) {
    this.loadNextPage();
  }
}

loadNextPage() {
  const startIndex = this.pageIndex * this.pageSize;
  const endIndex = startIndex + this.pageSize;
  const nextChunk = this.fullData.slice(startIndex, endIndex);

  if (nextChunk.length > 0) {
    this.viewData = [...this.viewData, ...nextChunk];
    this.dataSource.data = this.viewData;
    this.pageIndex++;
  }
}


  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

  selectRow(row) {
    this.selection.toggle(row);
    this.dialogRef.close(row);
  }
  closedialog() {
    this.dialogRef.close();
  }

}
